module.exports = __webpack_public_path__ + "img/pdf_icon.5be6301f.svg";